import { useState } from "react";
import { ArrowLeft, Save, CopyPlus } from "lucide-react";
import { Button } from "@/components/kit";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export function FormActions({ testid, saveLabel, saving, onSave, onSaveNew, onBack, dirty }) {
  const [ask, setAsk] = useState(false);
  const back = () => (dirty ? setAsk(true) : onBack());
  return (
    <>
      <Button variant="ghost" icon={ArrowLeft} onClick={back} className="mr-auto px-3 sm:px-5" title="Voltar" aria-label="Voltar" data-testid={`${testid}-back-button`}><span className="hidden sm:inline">Voltar</span></Button>
      {onSaveNew && <Button variant="secondary" icon={CopyPlus} loading={saving === "new"} disabled={!!saving} onClick={onSaveNew} className="px-3 sm:px-5" data-testid={`${testid}-save-new-button`}>Salvar e Novo</Button>}
      <Button icon={Save} loading={saving === "save"} disabled={!!saving} onClick={onSave} className="px-3 sm:px-5" data-testid={`save-${testid}-button`}>{onSaveNew ? <><span className="sm:hidden">Salvar</span><span className="hidden sm:inline">{saveLabel}</span></> : saveLabel}</Button>
      <AlertDialog open={ask} onOpenChange={setAsk}>
        <AlertDialogContent className="bg-[var(--surface)] text-[var(--text)] border-[var(--border)] rounded-2xl" data-testid={`${testid}-leave-dialog`}>
          <AlertDialogHeader>
            <AlertDialogTitle>Sair sem salvar?</AlertDialogTitle>
            <AlertDialogDescription>As alterações feitas neste formulário serão perdidas.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid={`${testid}-leave-cancel`}>Continuar editando</AlertDialogCancel>
            <AlertDialogAction onClick={onBack} style={{ background: "var(--danger)" }} data-testid={`${testid}-leave-confirm`}>Sair sem salvar</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
